import {
  IncentiveEvaluationMessage,
  IncentiveEvaluationMessages,
} from 'components/incentive-evaluation-messages/incentive-evaluation-messages';

export const CART_V2_MAIN_LAYOUT_MAX_WIDTH = 912;
export const CART_V2_INNER_LAYOUT_MAX_WIDTH = 560;

export const StyledIncentiveEvaluationMessages = IncentiveEvaluationMessages.withConfig({
  borderWidth: 'px',
  borderColor: Styles.color.red,
  padding: '$4',
  alignItems: 'center',
});

export const StyledIncentiveEvaluationMessage = IncentiveEvaluationMessage.withConfig({
  borderWidth: 'px',
  borderColor: Styles.color.red,
  padding: '$4',
});
